/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericDialogComponent } from './generic-dialog.component';
import { MaterialModule } from '../material/material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerSupportDialogExtensionComponent } from './customer-support-dialog-extension/customer-support-dialog-extension.component';
import { SelectionDialogComponent } from './selection-dialog/selection-dialog.component';

@NgModule({
	declarations: [GenericDialogComponent, CustomerSupportDialogExtensionComponent, SelectionDialogComponent],
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
	providers: [],
	exports: [GenericDialogComponent, CustomerSupportDialogExtensionComponent, SelectionDialogComponent],
})
export class GenericDialogModule {}
